import { Autocomplete, Box, Paper, Stack, styled, TextField } from '@mui/material'
import React, { useEffect } from 'react'

import { FontStyle, QuestionData, defaultBottomPadding, defaultInnerStyle, defaultContainerStyle } from '../../constants';
import { CustomPaper, StyledTextField } from '../AutocompleteUtils';
import CheckButton from '../CheckButton';
import HeartButton from '../HeartButton'
import SimpleButton from '../SimpleButton';
import TempDisplay from '../TempDisplay';

const styles = {
  container: {
    width: '100%',
    height: '100%',
    paddingTop: '2rem',
    paddingBottom: defaultBottomPadding,
  },
  inner: {
    ...defaultInnerStyle,
  },
  body: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'center',
    lineHeight: '1.4',
    maxWidth: '500px',
  },
  search: {
    width: '100%',
    maxWidth: '500px',
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: '4px',
    border: '1px solid rgb(204, 204, 204)',
  },
}
const numNeeded = 0;
const numMax = 100;
const initialLength = 10;


const Q3_Language = ({ selected, setSelected, setQuestionsDone, questionNum, options }) => {
  const [extraValues, setExtraValues] = React.useState([]);
  useEffect(() => {
    if (selected[questionNum].length >= numNeeded && selected[questionNum].length <= numMax) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
    } else {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }))
    }
  }, [selected])
  useEffect(() => {
    const originalIdx = selected[questionNum].filter(i => i < initialLength);
    const extraIdx = extraValues.map(v => options.indexOf(v));
    setSelected(s => { return { ...s, [questionNum]: [...originalIdx, ...extraIdx] } })
  }, [extraValues])
  return (
    <Stack direction='column' sx={styles.container} alignItems='center' spacing={3}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Box sx={styles.body}>Add any languages other than English you are comfortable working in, so we can show you relevant jobs.</Box>
      <Stack direction='row' sx={styles.inner} alignItems='center' justifyContent='center' flexWrap='wrap' spacing={0} gap={1}>
        {options.slice(0, initialLength).map((option, i) => {
          return (
            <SimpleButton key={i} text={option} selected={selected[questionNum].includes(i)} setSelected={() => {
              if (selected[questionNum].includes(i)) {
                setSelected(s => { return { ...s, [questionNum]: s[questionNum].filter((item) => item !== i) } })
              } else if (selected[questionNum].length < numMax) {
                setSelected(s => { return { ...s, [questionNum]: [...s[questionNum], i] } })
              }
            }}
              disabled={selected[questionNum].length >= numMax && !selected[questionNum].includes(i)}
            />
          )
        })}
      </Stack>
      <Stack direction='column' sx={styles.inner} alignItems='center' justifyContent='center' spacing={1}>
        <Box sx={styles.body}>Can't find a language above?</Box>
        <Autocomplete
          multiple
          options={options.slice(initialLength)}
          getOptionLabel={(option) => option}
          defaultValue={extraValues}
          value={extraValues}
          onChange={(event, newValue) => {
            setExtraValues(newValue);
          }}
          sx={{
            width: '100%',
            '& .MuiFormControl-root': {
              border: 'none',
            }
          }}
          PaperComponent={CustomPaper}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props} style={{ textAlign: 'center', width: '100%' }}>
                <Box sx={{ margin: 'auto' }}>{option}</Box>
              </li>
            )
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
              sx={styles.search}
              variant="standard"
              placeholder="Type language here..."
            />
          )}
        />
      </Stack>
    </Stack>
  )
}

export default Q3_Language